import { noop } from 'lodash';
import React, { FC, useMemo } from 'react';
import { IChildrenProps } from 'types/common';

export interface ISession {
	isFirstSeen: boolean;
	setFirstSeen: React.Dispatch<React.SetStateAction<boolean>>;
}
export const SessionContext = React.createContext<ISession>({
	isFirstSeen: false,
	setFirstSeen: noop
});

export const SessionProvider: FC<IChildrenProps> = ({ children }) => {
	const [isFirstSeen, setFirstSeen] = React.useState(false);

	const session = useMemo<ISession>(
		() => ({
			isFirstSeen,
			setFirstSeen
		}),
		[isFirstSeen, setFirstSeen]
	);

	return (
		<SessionContext.Provider value={session}>
			{children}
		</SessionContext.Provider>
	);
};
